import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class GeocercasServiceService {

  constructor(
    private http: HttpClient,
  ) { }


  addGeocerca(params){
    //console.log(params)
    return this.http.post(`${environment.baseUrl}inforef/cargageocerca`, params);
  }

  deleteGeocerca(gid){
      //console.log(gid)
      return this.http.delete(`${environment.baseUrl}inforef/deletegeocerca/`+ gid);
  }

}
